// Estilos de react-select (Categoría / Sección) en los modales de producto (EditProductModal y
// NewProductModal): el mismo aspecto que los demás campos (FormDialog.formInput): 48px, radio 10px,
// foco verde. El menú se dibuja en <body> (selectProps.menuPortalTarget) para que el scroll del modal
// no lo corte.
export const selectStyles = {
    control: (provided, state) => ({
        ...provided,
        minHeight: 48,
        borderRadius: 10,
        borderColor: 'var(--color-gray-350)',
        boxShadow: state.isFocused ? '0 0 0 2px var(--color-primary-dark)' : 'none',
        '&:hover': { borderColor: 'var(--color-gray-500)' },
    }),
    input: (provided) => ({
        ...provided,
        // anula el input global de base.css (borde !important, 593×90)
        '& input': {
            border: 'none !important',
            boxShadow: 'none !important',
            outline: 'none !important',
            height: 'auto',
        },
    }),
    placeholder: (provided) => ({ ...provided, color: 'var(--color-gray-500)' }),
    menuPortal: (provided) => ({ ...provided, zIndex: 1001 }), // sobre el modal (--z-modal: 1000)
    option: (provided, state) => ({
        ...provided,
        backgroundColor: state.isSelected
            ? 'var(--color-primary-alt)'
            : state.isFocused ? 'var(--color-gray-100)' : provided.backgroundColor,
    }),
};

export const selectProps = {
    isClearable: true,
    styles: selectStyles,
    menuPortalTarget: typeof document !== 'undefined' ? document.body : null,
    menuPlacement: 'auto',
};
